import { EpiLink } from '@api/types';
import { useAppDispatch, useAppSelector } from '@hooks/redux/store.hooks';
import { getCurrentPageId } from '@store/app/app.slice';
import { setAllModals } from '@store/modal/modal.slice';
import { getLinkData } from '@utils/links.utils';
import { useNavigate } from 'react-router-dom';

export const useReload = () => () => window.location.reload();

export const useScrollToTop = () => () => window.scrollTo({ top: 0, behavior: 'smooth' });

export const useInternalRedirect = () => {
  const scrollToTop = useScrollToTop();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const redirect = (path: string, noScroll?: boolean) => {
    if (noScroll !== true) {
      scrollToTop();
    }
    dispatch(setAllModals(false));
    navigate(path);
  };

  return redirect;
};

export const useLinkData = (link: EpiLink) => {
  const currentPageGuid = useAppSelector(getCurrentPageId);
  const isActivePath = link.contentLink?.guidValue === currentPageGuid;
  return { isActivePath, ...getLinkData(link) };
};
